// extracted by mini-css-extract-plugin
module.exports = {"variables":"\"../css/variables.css\"","BASE_COLOR":"#0c8eff","BTN_HOVER_COLOR":"#009AEF","TABLE_THEAD_BGCOLOR":"undefined"};